export default `
<footer class="unauthenticated-footer" role="contentinfo">
  <div class="unauthenticated-footer__container">
    <div class="unauthenticated-footer__top">
      <div class="unauthenticated-footer__logo">
        <a href="/" rel="noopener noreferrer">
          <img alt="uTest" src="https://s3.us-east-1.amazonaws.com/utest.com/assets/resources/img/u-test-logo-white.svg">
        </a>
      </div>
      <div class="unauthenticated-footer__social-cta unauthenticated-nav-bar--hidden-desktop-md unauthenticated-nav-bar--hidden-desktop-sm unauthenticated-nav-bar--hidden-tablet">Follow Us On Social</div>
      <div class="unauthenticated-footer__social">
        <div class="unauthenticated-footer__social-cta unauthenticated-nav-bar--hidden-mobile">Follow Us On Social</div>
        <div class="unauthenticated-footer__social-links">
          <a class="unauthenticated-footer__social-link" href="https://x.com/utest" target="_blank">
            <img src="https://s3.us-east-1.amazonaws.com/utest.com/assets/img/twitter.svg" alt="X">
          </a>
          <a class="unauthenticated-footer__social-link" href="https://www.instagram.com/utestinc/" target="_blank" title="Follow on Instagram">
            <img src="https://s3.us-east-1.amazonaws.com/utest.com/assets/img/instagram.svg" alt="Instagram">
          </a>
          <a class="unauthenticated-footer__social-link" href="https://www.facebook.com/utest" target="_blank">
            <img src="https://s3.us-east-1.amazonaws.com/utest.com/assets/img/facebook.svg" alt="Facebook">
          </a>
          <a class="unauthenticated-footer__social-link" href="https://www.linkedin.com/company/utest" target="_blank">
            <img src="https://s3.us-east-1.amazonaws.com/utest.com/assets/img/linkedin.svg" alt="LinkedIn">
          </a>
          <a class="unauthenticated-footer__social-link" href="https://www.reddit.com/r/UTEST/" target="_blank">
            <img src="https://s3.us-east-1.amazonaws.com/utest.com/assets/img/reddit.svg" alt="Reddit">
          </a>
        </div>
      </div>
    </div>
    <div class="unauthenticated-footer__copyright unauthenticated-nav-bar--hidden-tablet unauthenticated-nav-bar--hidden-desktop-sm unauthenticated-nav-bar--hidden-desktop-md ">
      © {{$ctrl.year}} Applause App Quality, Inc.
    </div>
    <div class="unauthenticated-footer__nav">
      <div class="unauthenticated-footer__copyright unauthenticated-nav-bar--hidden-tablet unauthenticated-nav-bar--hidden-mobile">
        © {{$ctrl.year}} Applause App Quality, Inc.
      </div>
      <nav aria-label="Footer Navigation">
        <ul class="unauthenticated-footer__nav-items">
          <li class="unauthenticated-footer__nav-item unauthenticated-nav-bar--hidden-desktop-sm unauthenticated-nav-bar--hidden-desktop-md unauthenticated-nav-bar--hidden-mobile">
            © {{$ctrl.year}} Applause App Quality, Inc.
          </li>
          <li class="unauthenticated-footer__nav-item">
            <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a>
          </li>
          <li class="unauthenticated-footer__nav-item">
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          </li>
          <li class="unauthenticated-footer__nav-item">
            <a href="/ai-guidelines" target="_blank" rel="noopener noreferrer">AI Guidelines</a>
          </li>
          <li class="unauthenticated-footer__nav-item--onetrust">
            <!-- OneTrust Cookies Settings button start -->
            <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>
            <!-- OneTrust Cookies Settings button end -->
          </li>
          <li class="unauthenticated-footer__nav-item">
            <a href="/phishing-notice" target="_blank" rel="noopener noreferrer">Phishing Notice</a>
          </li>
          <li class="unauthenticated-footer__nav-item">
            <a href="https://support.utest.com/csp" target="_blank">Help & Support</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</footer>
`;
